/**
 * useIsDaoMember — DAO-FOUND-03 (Phase 3)
 *
 * Returns whether the connected wallet is a DAO member (owner).
 *
 * Logic source: old-front-reference/pages/dao/hooks/queries/useIsDaoMember.ts
 * Contract: Election.sol → isOwner(address) → bool
 * (isOwner is on Election.sol, NOT DAO.sol — see DAO ABI header comment)
 *
 * L7: Returns isOwner only — no voting-period compound.
 * No query cache override (feedback_query_staletime).
 */

import { useAccount, useReadContract } from "wagmi";
import { EXPECTED_CHAIN_ID } from "@/configs/expected-chain";
import { ELECTION_ABI } from "@/contract/abi/election";
import { ContractAddress } from "@/contract/addresses";

export function useIsDaoMember() {
  const { address } = useAccount();
  return useReadContract({
    abi: ELECTION_ABI,
    address: ContractAddress.ELECTION,
    chainId: EXPECTED_CHAIN_ID,
    functionName: "isOwner",
    args: address ? [address] : undefined,
    query: { enabled: !!address, retry: false },
  });
}
